import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);
import Layout from '@/layout';
export var constantRoutes = [{
  path: '/redirect',
  component: Layout,
  hidden: true,
  children: [{
    path: '/redirect/:path*',
    component: function component() {
      return import('@/views/redirect');
    }
  }]
}, {
  path: '/login',
  component: function component() {
    return import('@/views/login/index');
  },
  hidden: true
}, {
  path: '/404',
  component: function component() {
    return import('@/views/404');
  },
  hidden: true
}, {
  path: '/403',
  component: function component() {
    return import('@/views/403');
  },
  hidden: true
}, {
  path: '',
  component: Layout,
  hidden: true,
  redirect: 'dashboard',
  children: [{
    path: 'dashboard',
    component: function component() {
      return import('@/views/dashboard/index');
    },
    name: '工作台',
    meta: {
      title: '工作台',
      icon: 'dashboard',
      noCache: true,
      affix: true
    }
  }, {
    path: 'chart1',
    component: function component() {
      return import('@/views/dashboard/chart1');
    },
    name: '图表',
    meta: {
      title: '图表',
      icon: 'dashboard',
      noCache: true,
      affix: true
    }
  }, {
    path: '/teaching/student/detail/:id',
    component: function component() {
      return import('@/views/student/base/Detail');
    },
    name: 'student-detail',
    meta: {
      title: '学生信息'
    },
    hidden: true
  }, {
    path: '/teaching/student/print',
    component: function component() {
      return import('@/views/student/base/Print');
    },
    name: 'studentPrint',
    meta: {
      title: '打印学生信息',
      icon: 'student'
    },
    hidden: true
  }, {
    path: '/setting/user/print',
    component: function component() {
      return import('@/views/admin/user/UserPrint');
    },
    name: 'userPrint',
    meta: {
      title: '打印用户信息',
      icon: 'user'
    },
    hidden: true
  }, {
    path: '/education/rss/news/:id(\\d+)',
    component: function component() {
      return import('@/views/rss/news/Form');
    },
    hidden: true,
    name: 'newsEdit',
    meta: {
      title: '编辑新闻',
      icon: 'rss'
    }
  },
  // 学费分摊功能路由
  {
    path: '/student/payment/allocation',
    component: function component() {
      return import('@/views/student/payment/allocation/index');
    },
    hidden: true,
    name: 'allocationIndex',
    meta: {
      title: '学费分摊功能',
      icon: 'fee'
    }
  }, {
    path: '/student/payment/details',
    component: function component() {
      return import('@/views/student/payment/allocation/PaymentDetails');
    },
    hidden: true,
    name: 'paymentDetails',
    meta: {
      title: '交费明细表',
      icon: 'fee'
    }
  }, {
    path: '/student/payment/allocation-details',
    component: function component() {
      return import('@/views/student/payment/allocation/detail');
    },
    hidden: true,
    name: 'allocationDetails',
    meta: {
      title: '费用分摊明细表',
      icon: 'fee'
    }
  }, {
    path: '/student/payment/yearly-summary',
    component: function component() {
      return import('@/views/student/payment/allocation/YearlySummary');
    },
    hidden: true,
    name: 'yearlySummary',
    meta: {
      title: '年度费用分摊汇总表',
      icon: 'fee'
    }
  }, {
    path: '/student/payment/test',
    component: function component() {
      return import('@/views/student/payment/allocation/TestPage');
    },
    hidden: true,
    name: 'paymentTest',
    meta: {
      title: '学费分摊功能测试',
      icon: 'fee'
    }
  },
  // 学生退费管理路由
  {
    path: '/student/refund',
    component: function component() {
      return import('@/views/student/refund/index');
    },
    name: 'StudentRefund',
    meta: {
      title: '学生退费管理',
      icon: 'refund'
    },
    hidden: true
  }, {
    path: '/student/refund/:id',
    component: function component() {
      return import('@/views/student/refund/detail');
    },
    name: 'StudentRefundDetail',
    meta: {
      title: '退费记录详情'
    },
    hidden: true
  }, {
    path: '/student/refund/statistics',
    component: function component() {
      return import('@/views/student/refund/statistics');
    },
    name: 'StudentRefundStatistics',
    meta: {
      title: '退费统计分析'
    },
    hidden: true
  }, {
    path: '/student/refund/:id/allocation-changes',
    component: function component() {
      return import('@/views/student/refund/allocation-changes');
    },
    name: 'StudentRefundAllocationChanges',
    meta: {
      title: '分摊变更记录'
    },
    hidden: true
  }, {
    path: '/exam/marking/detail/:paperQuestionId',
    component: function component() {
      return import('@/views/exam/marking/detail');
    },
    name: 'examMarkingDetail',
    meta: {
      title: '阅卷打分'
    },
    hidden: true
  },
  // 宿舍重构 - 全景查询
  {
    path: '/dorm/overview',
    component: function component() {
      return import('@/views/dorm/overview/index');
    },
    name: 'DormOverview',
    meta: {
      title: '宿舍全景查询',
      icon: 'room'
    },
    hidden: false
  }]
}];
var createRouter = function createRouter() {
  return new Router({
    // mode: 'history', // require service support
    scrollBehavior: function scrollBehavior() {
      return {
        y: 0
      };
    },
    routes: constantRoutes
  });
};
var router = createRouter();
export function resetRouter() {
  var newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}
export default router;